<div class="sabis-app-search">
  <mat-icon fontIcon="search"></mat-icon>
  <input matInput placeholder="Search..." [matAutocomplete]="auto" (keydown.enter)="onEnterKeyDownEvent($event)" [value]="searchText">
  <mat-autocomplete #auto="matAutocomplete" [hideSingleSelectionIndicator]="true">
    @if (isLoading) {
      <mat-option disabled="true">Loading...</mat-option>
    }
    @if (!isLoading) {
      @for (result of searchResults; track result) {
        <mat-option [value]="result.modelDescription" (onSelectionChange)="onOptionSelected($event, result)" class="sabis-app-search__result-item">
          <mat-icon [fontIcon]="result.icon"></mat-icon>
          <div class="sabis-app-search__result-item-text">
            <span>{{ result.modelDescription }}</span><br />
            <p>Id: {{result.modelId}}</p>
            <p>{{ result.resultColumnDescription }}: {{result.resultColumnValue}}</p>
          </div>
        </mat-option>
      }
    }
    @if (resultResultMessage !== '') {
      <mat-option disabled="true">{{ resultResultMessage }}</mat-option>
    }
  </mat-autocomplete>
</div>
